import { render } from "./PrivateLogin.vue?vue&type=template&id=90d984a0&ts=true"
import script from "./PrivateLogin.vue?vue&type=script&lang=ts"
export * from "./PrivateLogin.vue?vue&type=script&lang=ts"

import "./PrivateLogin.vue?vue&type=style&index=0&id=90d984a0&lang=less"

import exportComponent from "/builds/fe/keyan-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__